import React from "react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Code = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="stroke-current h-8 w-8 flex-shrink-0"
  >
    <path d="m16 18 6-6-6-6M8 6l-6 6 6 6" />
  </svg>
)

const ExternalLink = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="stroke-current fill-current h-8 w-8 flex-shrink-0"
  >
    <g fill="none" fill-rule="evenodd">
      <path d="M18 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5M15 3h6v6M10 14L20.2 3.8" />
    </g>
  </svg>
)

const Project = ({ content }) => {
  const { excerpt, id, body, frontmatter, fields } = content
  // const image = getImage(frontmatter.screenshot)
  return (
    <section id="project" className="mb-20 bg-tertiary">
      <div className="w-full flex flex-col items-center p-6" key={id}>
        <div className="relative overflow-hidden w-full">
          <div className="mb-4 lg:mb-0">
            <div className="mx-auto flex-shrink-0 relative w-80 h-60 hover:scale-125 hover:z-10 transform ease-in-out transition duration-500 ">
              <img src={frontmatter.thumbnailUrl} className="aspect-[1/1] object-cover object-center h-full w-full" alt={frontmatter.title} />
            </div>
          </div>
        </div>
        <div className="py-6">
          <h1 className="text-md md:text-xl font-bold uppercase lg:text-transparent lg:bg-clip-text lg:bg-gradient-to-br lg:from-blue-600 lg:via-blue-400 lg:to-purple-800 lg:dark:from-gray-500 lg:dark:via-gray-300 lg:dark:to-white">
            {frontmatter.category}
          </h1>
          {/* <Link to={fields.slug}> */}
          <h1 className="font-body2 text-xl md:text-2xl lg:text-3xl font-bold mb-6 text-quarternary">
            {frontmatter.title}
          </h1>
          {/* </Link> */}
          <p className="font-light text-base sm:text-lg md:text-2xl mb-6">
            <MDXRenderer>{body}</MDXRenderer>
          </p>
          <div className="w-full whitespace-nowrap overflow-hidden flex flex-wrap text-sm md:text-md lg:text-lg font-bold lg:text-transparent lg:bg-clip-text lg:bg-gradient-to-br lg:from-blue-600 lg:via-blue-400 lg:to-purple-800 lg:dark:from-gray-500 lg:dark:via-gray-300 lg:dark:to-white mb-6">
            {frontmatter.tags.map((tag, key) => {
              return <p className="mr-2 font-mono uppercase">{tag}</p>
            })}
          </div>
          {frontmatter.live === "true" ? (
            <div className="justify-between flex mx-auto mt-4">
              <span className="transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110 text-blue-400 hover:text-blue-700 dark:text-gray-400 dark:hover:text-white">
                <a
                  href={frontmatter.external}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <ExternalLink />
                </a>
              </span>
            </div>
          ) : (
            <div className="flex flex-row space-x-4 mt-4">
              <span className="transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110 text-blue-400 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                <a
                  href={frontmatter.external}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <Code />
                </a>
              </span>
              <span className="transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110 text-blue-400 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                <a
                  href={frontmatter.external}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <ExternalLink />
                </a>
              </span>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Project
